(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	var mod = $('#employees');
	var items = mod.find('li');

	items.each(function () {
		var item = $(this);
		var thumb = item.find('.employee-thumbnail');
		var toggle = item.find('.employee-toggle');
		var close = item.find('.employee-close');

		var toggleOpen = function () {
			if (thumb.is('.open')) {
				thumb.removeClass('open');
			}
			else {
				items.find('.employee-thumbnail.open').removeClass('open');
				thumb.addClass('open');
			}
		};

		// thumb.on('click', toggleOpen);
		toggle.on('click', toggleOpen);
		close.on('click', function () {
			thumb.removeClass('open');
		});
	});
})();
